export default __webpack_public_path__ + "images/BU.454b76b.png";